import React from "react";
import ImageWithBasePath from "../img/ImageWithBasePath";
// import { Link } from "react-router-dom";

const CarImage = ({ Car }: { Car: { image?: string, name?: string } }) => {


    return (
        <>
            {/* Add Card Modal */}
            <div
                className="modal new-modal fade"
                id="car_image"
                data-keyboard="false"
                data-backdrop="static"
            >
                <div className="modal-dialog modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{Car?.name}</h4>
                            <button
                                type="button"
                                className="close-btn"
                                data-bs-dismiss="modal"
                            >
                                <span>×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <ImageWithBasePath
                                width={"100%"}
                                height={"auto"}
                                src={Car?.image}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Card Modal */}
        </>
    );
};

export default CarImage;
